import React,{useState} from 'react'
import OEMAddEdit from './OEMAddEditNew'
import OEMBre from './OEMBre'
export default function Main({handleTab,Editdata}) {
    const [tab,setTab]=useState("addEditOEM")
    const [pageData,setPageData]=useState({})

    const handlePage = (type,data)=>{
        setPageData(data)
        setTimeout(()=>{
            setTab(type)
        },200)
    }
  return (
   <>
    {
        tab === "addEditOEM" ?
        <OEMAddEdit handlePage={handlePage} handleTab={handleTab} Editdata={Editdata}/> :''
    }
    {
        tab === "OEMBre" ?
        <OEMBre handleTab={handleTab} pageData={pageData}/> :''
    }
   </>
  )
}
